const $blogAsideWrapper = $('.js-blogAsideWrapper')

if ($blogAsideWrapper.length > 0) {
  $(window).on('load resize scroll', () => {
    const scrolled = $(window).scrollTop()
    const value = -Math.round(scrolled / 3)

    $blogAsideWrapper.css('transform', `translate3d(0, ${value}px, 0)`)
  })
}
